/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

      if (this.collection_style == 'slider') {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        cellSelector: '.product__thumbnail',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: true,
        initialIndex: 0,
        arrowShape: arrowShape
      });

      $sliderEl.on('settle.flickity', function () {
        setTimeout(() => {
          $sliderEl.addClass('flickity-slider-ready');
        }, 500);
      });

      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });
    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;